// extracted by css-extract-rspack-plugin
export default {"radio-item-auto":"ChangeAllBidsBudgetDrop-module__radio-item-auto--MBp86","radioItemAuto":"ChangeAllBidsBudgetDrop-module__radio-item-auto--MBp86"};